<template>
  <div>
    <VInputWrapper
      :label="trans('event.assessment_configs.edit.name')"
      name="name"
      :required="true"
      :errors="getErrorsForField('name')"
    >
      <input
        id="name"
        v-model="name"
        class="form-control"
      >
    </VInputWrapper>
    <div class="d-flex mt-3">
    <VInputWrapper
      :label="trans('event.assessment_configs.edit.starttime')"
      name="starttime"
      :required="true"
      style="width:50%"
      class="me-2"
      :errors="getErrorsForField('starttime')"
    >
      <TimeSelect
        id="timeSelect"
        v-model="starttime"
        class="w-100"
        format="HH:mm"
        :clearable="false"
        :picker-options="{
          start: roundToNearestFiveMinutes(moment(parentEvent.starttime)).format('HH:mm'),
          step: '00:05',
          end: roundToNearestFiveMinutes(moment(parentEvent.endtime)).format('HH:mm'),
          format : 'HH::mm'
        }"
        value-format="HH:mm"
      />
    </VInputWrapper>
    <VInputWrapper
      :label="trans('event.assessment_configs.edit.endtime')"
      name="endtime"
      :required="true"
      class="ms-2"
      style="width:50%"
      :errors="getErrorsForField('endtime')"
    >
      <TimeSelect
        id="timeSelect"
        v-model="endtime"
        class="w-100"
        format="HH:mm"
        :picker-options="{
          start: roundToNearestFiveMinutes(moment(parentEvent.starttime)).format('HH:mm'),
          step: '00:05',
          end: roundToNearestFiveMinutes(moment(parentEvent.endtime)).format('HH:mm'),
          format : 'HH::mm'
        }"
        value-format="HH:mm"
      />
    </VInputWrapper>
    </div>
    <div class="d-flex justify-content-between mt-3">
      <div class="p-1 py-2 flex-grow-1">
        <div class="mb-2 fw-bold">
          {{ trans_choice('core.students', 2) }}
        </div>
        <div
          v-if="students.length > 0"
          class="d-flex flex-column"
        >
          <div
            v-for="student in students"
            :key="student.id"
            class="mb-2"
          >
            {{ student.firstName }} {{ student.lastName }}
          </div>
        </div>
        <div v-else>
          -
        </div>
      </div>
      <div class="p-1 py-2 flex-grow-1">
        <div class="mb-2 fw-bold">
          {{ trans_choice('core.classrooms', 2) }}
        </div>
        <div
          v-if="assessmentConfig.event.classrooms && assessmentConfig.event.classrooms.length > 0"
          class="d-flex flex-column"
        >
          <div
            v-for="classroom in classrooms"
            :key="classroom.id"
            class="mb-2"
          >
            {{ classroom.name }}
          </div>
        </div>
        <div v-else>
          -
        </div>
      </div>
      <div class="p-1 py-2 flex-grow-1">
        <div class="mb-2 fw-bold">
          {{ trans_choice('core.lecturers', 2) }}
        </div>
        <div
          v-if="assessmentConfig.event.lecturers && assessmentConfig.event.lecturers.length > 0"
          class="d-flex flex-column"
        >
          <div
            v-for="lecturer in lecturers"
            :key="lecturer.id"
            class="mb-2"
          >
            {{ lecturer.name }}
          </div>
        </div>
        <div v-else>
          -
        </div>
      </div>
    </div>
    <div class="d-flex flex-row-reverse">
      <button
        type="button"
        class="btn btn-primary mt-3"
        :disabled="isSaving"
        @click="edit"
      >
        {{ trans('core.edit') }} <Loader v-if="isSaving" />
      </button>
      <button
          type="button"
          class="btn btn-danger mt-3"
          :disabled="isDeleting"
          @click="deleteEvent()"
      >
        {{ trans('core.delete') }} <Loader v-if="isDeleting" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import errorsMixin from '@/mixins/errorsMixin'
import { TimeSelect } from 'element-ui'
import moment from 'moment'
export default {
  name: 'AssessmentConfigEventEditView',
  components: {
    TimeSelect,
  },
  mixins: [errorsMixin],
  props: {
    assessmentConfig: {
      required: true,
      type: Object,
    },
    parentEvent: {
      type: Object,
      isSaving: true,
    },
  },
  data () {
    return {
      editAssessmentConfig: null,
      event: null,
      name: null,
      starttime: null,
      endtime: null,
      isSaving: false,
      isDeleting: false
    }
  },
  computed: {
    ...mapState({
      students (state) {
        return this.assessmentConfig.event.students
          ? this.assessmentConfig.event.students.map(studentId => state.students.students[studentId])
          : []
      },
      classrooms (state) {
        return this.assessmentConfig.event.classrooms
          ? this.assessmentConfig.event.classrooms.map(classroomId => state.classrooms.classrooms[classroomId])
          : []
      },
      lecturers (state) {
        return this.assessmentConfig.event.lecturers
          ? this.assessmentConfig.event.lecturers.map(lecturerId => state.lecturers.lecturers[lecturerId])
          : []
      },
    }),
  },
  mounted () {
    this.editAssessmentConfig = this.assessmentConfig
    this.event = this.assessmentConfig.event
    this.name = this.event.name
    this.starttime = moment(this.event.starttime).format('HH:mm')
    this.endtime =moment(this.event.endtime).format('HH:mm')
  },
  methods: {
    edit () {
      this.isSaving = true
      this.clearErrors()
      const starttime = moment(new Date(`01/01/1970 ${this.starttime}`))
      const endtime = moment(new Date(`01/01/1970 ${this.endtime}`))
      this.$store.dispatch('updateEvent', {
        eventId: this.assessmentConfig.event.id,
        data: {
          name: this.name,
          starttime: moment(this.event.starttime).hours(starttime.hours()).minutes(starttime.minutes()).format('YYYY-MM-DD HH:mm:ss'),
          endtime: moment(this.event.endtime).hours(endtime.hours()).minutes(endtime.minutes()).format('YYYY-MM-DD HH:mm:ss'),
        },
      }).then(() => {
          this.$emit('close')
        })
        .catch(error => this.extractErrors(error))
        .finally(() => {
          this.isSaving = false
        })
    },
    deleteEvent (){
      this.isDeleting = true

      this.$store.dispatch('deleteEvent', {
        eventId: this.assessmentConfig.event.id,
        parentEventId: this.parentEvent.id,
      }).then(() => {
        this.$emit('close')
      }).catch(error => this.extractErrors(error))
        .finally(() => {
            this.isDeleting = false
          })
    },
    roundToNearestFiveMinutes(time) {
      const minutes = time.minutes();
      const rounding = 5 * Math.round(minutes / 5);
      return time.clone().minutes(rounding).seconds(0);
    }
  },
}
</script>
<style lang="scss" scoped>
.btn-primary {
  background-color: #25167a !important;
}
</style>
